import { render, staticRenderFns } from "./ReportsConfig.vue?vue&type=template&id=9504f82e&scoped=true"
import script from "./ReportsConfig.vue?vue&type=script&lang=js"
export * from "./ReportsConfig.vue?vue&type=script&lang=js"
import style0 from "./ReportsConfig.vue?vue&type=style&index=0&id=9504f82e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9504f82e",
  null
  
)

export default component.exports